<template>
  <FloatingPopup
    v-model="isOpen"
    :placement="position"
    :offset="offset"
    :teleport="teleport"
    :teleportTo="teleportTo"
    :popupClass="style.tooltip"
  >
    <template #trigger="{open, close}">
      <span
        :class="style.trigger"
        data-floating-trigger
        @mouseenter="scheduleOpen(open, $event)"
        @mouseleave="closeTooltip(close)"
        @focusin="scheduleOpen(open, $event)"
        @focusout="closeTooltip(close)"
      >
        <slot />
      </span>
    </template>

    <span role="tooltip" :class="style.content">{{ text }}</span>
  </FloatingPopup>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";

import FloatingPopup from "@/elements/UI/popup/FloatingPopup/FloatingPopup.vue";
import style from "./Tooltip.module.scss";

type PositionTooltip = "top" | "bottom" | "left" | "right";
type ClosePopup = () => void;
const SHOW_DELAY = 100;

export default defineComponent({
  name: "TooltipComponent",

  components: {
    FloatingPopup
  },

  props: {
    position: {
      type: String as PropType<PositionTooltip>,
      default: "top"
    },
    offset: {
      type: Number,
      default: 8
    },
    text: {
      type: String,
      default: ""
    },
    teleport: {
      type: Boolean,
      default: true
    },
    teleportTo: {
      type: String,
      default: "body"
    }
  },

  data() {
    return {
      style,
      isOpen: false,
      openTimeoutId: undefined as number | undefined
    };
  },

  beforeUnmount() {
    this.clearOpenTimeout();
  },

  methods: {
    scheduleOpen(open: EventListener, event: Event): void {
      this.clearOpenTimeout();

      this.openTimeoutId = window.setTimeout(() => {
        this.openTimeoutId = undefined;
        open(event);
      }, SHOW_DELAY);
    },

    closeTooltip(close: ClosePopup): void {
      this.clearOpenTimeout();
      close();
    },

    clearOpenTimeout(): void {
      if (this.openTimeoutId === undefined) {
        return;
      }

      window.clearTimeout(this.openTimeoutId);
      this.openTimeoutId = undefined;
    }
  }
});
</script>
